import React from 'react';
import Header from '../components/Header/Header';
import ConsultingHero from '../components/ConsultingHero/ConsultingHero';
import FocusAreas from '../components/FocusAreas/FocusAreas';
import Footer from '../components/Footer/Footer';
import Partnership from '../components/Partnership/Partnership';
import TrackRecord from '../components/TrackRecord/TrackRecord';
import CoreBusiness from '../components/CoreBusiness/CoreBusiness';
import NewFrontiers from '../components/NewFrontiers/NewFrontiers';
import PlanAhead from '../components/PlanAhead/PlanAhead';
import CoCreateCTA from '../components/CoCreateCTA/CoCreateCTA';

const ConsultingPage = () => {
  return (
    <>
      <Header />
      <main>
        <ConsultingHero />
        <Partnership />
        <FocusAreas />
        <CoreBusiness />
        <TrackRecord />
         <NewFrontiers />
         <PlanAhead />
        {/* You can add more consulting-specific sections here later */}
        <CoCreateCTA />
      </main>
      <Footer />
    </>
  );
};

export default ConsultingPage;